(ns app.front.view.group.admin.escrow.groups
  "Selecting which groups use the escrow functionality"
  (:require [app.domain.group.model :as group-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui.multi-select :as ms]
            [clojure.data :as cd]
            [clojure.set :as set]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::authority-groups
  (fn [[_ group-id]]
    (rf/subscribe [::entities/entities {:entity/parent group-id
                                        :entity/type   :entity.type/group
                                        :group/type    :group.type/application-authority}]))
  (fn [groups _]
    (->> groups
         (sort-by :group/name))))

(rf/reg-sub ::groups-with-escrow
  (fn [[_ group-id]]
    (rf/subscribe [::authority-groups group-id]))
  (fn [groups _]
    (->> groups
         (filter #(group-model/has-feature? % :group.feature/use-escrow-payments))
         set)))

(rf/reg-sub ::edit-pending-ids :-> ::edit-pending-ids)

(rf/reg-sub ::disabled-groups
  (fn [[_ group-id]]
    [(rf/subscribe [::authority-groups group-id])
     (rf/subscribe [::edit-pending-ids])])
  (fn [[groups ids] _]
    (->> groups
         (filter #(contains? ids (:db/id %)))
         set)))

(defn toggle-fn [db enabled?]
  (fn [group-id]
    [:dispatch [:comm/command-monitored
                {:command    :group/toggle-authority-group-feature-from-domain
                 :data       {:group-id       group-id
                              :feature        :group.feature/use-escrow-payments
                              :enabled?       enabled?
                              :entity/version (-> db
                                                  (get-in [::entities/entity-db group-id])
                                                  :entity/version)}
                 :on-success [::toggle-escrow.success group-id]}]]))

(rf/reg-event-fx ::toggle-escrow.success
  (fn [{:keys [db]} [_ group-id status resp]]
    {:db       (update db ::edit-pending-ids disj group-id)
     :dispatch [::entities/apply-changes status resp]}))

(rf/reg-event-fx ::toggle-escrow
  (fn [{:keys [db]} [_ add-for remove-from]]
    {:db (-> db
             (update ::edit-pending-ids set/union add-for remove-from))
     :fx (concat
           (->> add-for
                (map (toggle-fn db true)))
           (->> remove-from
                (map (toggle-fn db false))))}))

(defn escrow-auth-groups-selector [{:keys [tr group-id]}]
  (let [groups-with-escrow (<sub [::groups-with-escrow group-id])]
    [:section
     [ms/multi-checkbox
      {:id         "groups-with-escrow-select"
       :label-text (tr [:escrow.management/select-groups])
       :loading?   (<sub [:comm/command-processing? :group/toggle-authority-group-feature-from-domain])
       :tr         tr
       :values     (<sub [::authority-groups group-id])
       :selected   groups-with-escrow
       :disabled   (<sub [::disabled-groups group-id])
       :val->str   :group/name
       :on-change  (fn [new-groups-with-escrow]
                     (let [[remove-from add-for _] (cd/diff (du/entity-id-set groups-with-escrow)
                                                            (du/entity-id-set new-groups-with-escrow))]
                       (>evt [::toggle-escrow add-for remove-from])))}]]))
